<template>
  <div class="lp-root">
    <div id="layout-wrapper" class="lp-layout-wrapper">
      <nav class="lp-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')">
              <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" />
            </a>
            <button class="btn btn-sm btn-link text-muted p-0" @click="$router.push('/my-listings')">
              <i class="mdi mdi-arrow-left me-1"></i> My Listings
            </button>
          </div>
        </div>
      </nav>

      <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;">
        <div class="spinner-border text-warning"></div>
      </div>

      <div v-else class="container lp-container">
        <div class="lp-card mb-4">
          <div class="d-flex align-items-center gap-3">
            <div class="lp-thumb">
              <img v-if="listing.primary_photo || (listing.photos && listing.photos.length)" :src="photoUrl(listing.primary_photo || listing.photos[0].photo_url)" />
              <i v-else :class="getSpeciesIcon(listing.species_name)" style="font-size:24px;color:#BFA164;"></i>
            </div>
            <div class="flex-fill">
              <h5 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);">{{ listing.title }}</h5>
              <div style="color:#BFA164;font-weight:700;">KES {{ formatPrice(listing.price) }}</div>
              <span class="badge mt-1" :class="listing.status === 'active' ? 'bg-success bg-opacity-25 text-success' : 'bg-secondary bg-opacity-25 text-muted'">{{ listing.status }}</span>
            </div>
            <div class="d-none d-md-flex gap-2">
              <button class="btn btn-sm btn-outline-warning" @click="$router.push('/sell/edit/' + listing.id)">
                <i class="mdi mdi-pencil me-1"></i>Edit
              </button>
              <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/marketplace/listing/' + listing.id)">
                <i class="mdi mdi-eye me-1"></i>View
              </button>
            </div>
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3" v-for="stat in statsCards" :key="stat.label">
            <div class="lp-card text-center">
              <i :class="stat.icon" :style="'font-size:24px;color:' + stat.color"></i>
              <div class="lp-stat-val">{{ stat.value }}</div>
              <div class="lp-stat-lbl">{{ stat.label }}</div>
            </div>
          </div>
        </div>

        <div class="lp-card">
          <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);">
            <i class="mdi mdi-handshake me-2"></i>Offers Received
          </h6>

          <div v-if="loadingOffers" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-warning"></div>
          </div>

          <div v-else-if="offers.length === 0" class="text-center py-3">
            <p style="color:var(--fm-s,#6B6356);font-size:13px;">No offers yet</p>
          </div>

          <div v-else>
            <div v-for="(o, oi) in offers" :key="'o-'+oi" class="lp-offer-row">
              <div class="d-flex align-items-center gap-3">
                <div class="lp-avatar-sm">{{ getInitials(o.buyer_name) }}</div>
                <div class="flex-fill">
                  <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ o.buyer_name }}</div>
                  <div style="color:#BFA164;font-weight:700;">
                    KES {{ formatPrice(o.offered_price) }}
                    <span v-if="o.quantity > 1" style="color:var(--fm-s,#6B6356);font-weight:400;">× {{ o.quantity }}</span>
                  </div>
                  <div v-if="o.message" style="color:var(--fm-m,#A09888);font-size:12px;margin-top:2px;">{{ o.message }}</div>
                </div>
                <div class="text-end">
                  <span class="badge" :class="o.status === 'pending' ? 'bg-warning bg-opacity-15 text-warning' : o.status === 'accepted' ? 'bg-success bg-opacity-15 text-success' : o.status === 'countered' ? 'bg-info bg-opacity-15 text-info' : 'bg-secondary bg-opacity-15 text-muted'" style="font-size:10px;">{{ o.status }}</span>
                  <div style="color:var(--fm-s,#6B6356);font-size:10px;margin-top:4px;">{{ formatDate(o.created_at) }}</div>
                </div>
              </div>

              <div v-if="o.status === 'pending'" class="d-flex gap-2 mt-2 pt-2 lp-offer-actions">
                <button class="btn btn-sm btn-success flex-fill" @click="respondOffer(o.id, 'accept')">
                  <i class="mdi mdi-check me-1"></i>Accept
                </button>
                <button class="btn btn-sm btn-outline-warning flex-fill" @click="counterOffer(o)">
                  <i class="mdi mdi-swap-horizontal me-1"></i>Counter
                </button>
                <button class="btn btn-sm btn-outline-danger" @click="respondOffer(o.id, 'reject')">
                  <i class="mdi mdi-close"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
html[data-theme="light"] body {
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}
html[data-theme="dark"] body {
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}

html[data-theme="light"] .lp-root,
html[data-theme="light"] .lp-layout-wrapper,
html[data-theme="light"] .lp-container,
html[data-theme="light"] #layout-wrapper.lp-layout-wrapper {
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}

html[data-theme="dark"] .lp-root,
html[data-theme="dark"] .lp-layout-wrapper,
html[data-theme="dark"] .lp-container,
html[data-theme="dark"] #layout-wrapper.lp-layout-wrapper {
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}
</style>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E
}
html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777;
  --fm-m:#555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F7F5F2;
  --fm-bg3:#F0EBE4;
  --fm-br:#E8E2DA
}
</style>

<style scoped>
.lp-root,
.lp-layout-wrapper {
  background:var(--fm-bg2,#0F0F0F)!important;
  color:var(--fm-h,#F5F0E8)!important;
  min-height:100vh;
}

.lp-topbar {
  position:sticky;
  top:0;
  z-index:100;
  padding:12px 0;
  background:var(--fm-bg1,#141414)!important;
  backdrop-filter:blur(10px);
  border-bottom:1px solid var(--fm-br,#1E1E1E);
}

.lp-container {
  padding-top:80px;
  padding-bottom:60px;
  max-width:900px;
  background:transparent!important;
}

.lp-card {
  background:var(--fm-bg1,#141414)!important;
  border:1px solid var(--fm-br,#1E1E1E);
  border-radius:10px;
  padding:20px;
}

.lp-thumb {
  width:56px;
  height:56px;
  border-radius:8px;
  overflow:hidden;
  background:var(--fm-bg2,#0F0F0F)!important;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
}
.lp-thumb img {
  width:100%;
  height:100%;
  object-fit:cover;
}

.lp-stat-val {
  font-size:24px;
  font-weight:700;
  color:var(--fm-h,#F5F0E8)!important;
  margin-top:6px;
}
.lp-stat-lbl {
  font-size:11px;
  color:var(--fm-s,#6B6356)!important;
  margin-top:2px;
}

.lp-offer-row {
  padding:14px 0;
  border-bottom:1px solid var(--fm-br,#1A1A1A);
}
.lp-offer-row:last-child {
  border-bottom:none;
}

.lp-offer-actions {
  border-top:1px solid var(--fm-br,#1A1A1A);
}

.lp-avatar-sm {
  width:36px;
  height:36px;
  border-radius:50%;
  background:var(--fm-bg3,#1E1E1E)!important;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:12px;
  font-weight:700;
  color:#BFA164!important;
  flex-shrink:0;
}
</style>

<script>
import { executeJson, flocker, uploads } from "@/api";

export default {
  name: "ListingPerformance",
  data() {
    return {
      darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark') !== 'light',
      themeObserver: null,
      loading: true,
      loadingOffers: true,
      listing: {},
      offers: []
    };
  },
  computed: {
    statsCards() {
      var l = this.listing;
      return [
        { label: 'Views', value: l.view_count || 0, icon: 'mdi mdi-eye', color: '#6CB4EE' },
        { label: 'Saves', value: l.save_count || 0, icon: 'mdi mdi-heart', color: '#FF6B6B' },
        { label: 'Offers', value: l.inquiry_count || 0, icon: 'mdi mdi-handshake', color: '#BFA164' },
        { label: 'Shares', value: l.share_count || 0, icon: 'mdi mdi-share-variant', color: '#50C878' }
      ];
    }
  },
  mounted() {
    this.syncTheme();
    this.themeObserver = new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    var id = this.$route.params.id;
    if (id) this.load(id);
  },
  beforeUnmount() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  methods: {
    syncTheme() {
      var t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark';
      window.__flockrSetTheme(t);
      this.darkMode = t !== 'light';

      if (document.body) {
        document.body.setAttribute('data-sidebar', this.darkMode ? 'dark' : 'light');
        document.body.style.background = this.darkMode ? '#0A0A0A' : '#F7F5F2';
        document.body.style.color = this.darkMode ? '#F5F0E8' : '#1A1A1A';
      }

      var el = this.$el;
      if (el) {
        el.style.background = this.darkMode ? '#0A0A0A' : '#F7F5F2';
        el.style.color = this.darkMode ? '#F5F0E8' : '#1A1A1A';
      }
    },

    photoUrl(p) {
      if (!p) return '';
      if (p.startsWith && p.startsWith('http')) return p;
      return uploads + String(p).replace('uploads/', '');
    },

    async load(id) {
      this.loading = true;
      try {
        var r = await executeJson({
          function: "getListing",
          listingId: id,
          viewerId: sessionStorage.getItem('userId') || ''
        }, flocker);

        if (r.data.success) this.listing = r.data.data.listing || {};
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
      this.fetchOffers(id);
    },

    async fetchOffers(id) {
      this.loadingOffers = true;
      try {
        var r = await executeJson({ function: "getListingOffers", listingId: id }, flocker);
        if (r.data.success) this.offers = r.data.data.offers || [];
      } catch (e) {
        console.error(e);
      }
      this.loadingOffers = false;
    },

    async respondOffer(offerId, action) {
      try {
        var r = await executeJson({ function: "respondToOffer", offerId: offerId, action: action }, flocker);
        if (r.data.success) {
          var o = this.offers.find(function(x) { return x.id == offerId; });
          if (o) o.status = action === 'accept' ? 'accepted' : 'rejected';
        }
      } catch (e) {
        console.error(e);
      }
    },

    counterOffer(o) {
      var price = prompt('Enter counter price (KES):');
      if (price) {
        var msg = prompt('Message (optional):') || '';
        executeJson({
          function: "respondToOffer",
          offerId: o.id,
          action: 'counter',
          counterPrice: price,
          counterMessage: msg
        }, flocker).then(function(r) {
          if (r.data.success) o.status = 'countered';
        });
      }
    },

    formatPrice(a) {
      return a ? Number(a).toLocaleString('en-KE') : '0';
    },

    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    getInitials(n) {
      if (!n) return '?';
      return n.split(' ').map(function(w) { return w[0]; }).join('').substring(0, 2).toUpperCase();
    },

    getSpeciesIcon(s) {
      if (!s) return 'mdi mdi-paw';
      s = s.toLowerCase();
      if (s.indexOf('cattle') >= 0 || s.indexOf('cow') >= 0) return 'mdi mdi-cow';
      if (s.indexOf('goat') >= 0) return 'mdi mdi-unicode';
      if (s.indexOf('sheep') >= 0) return 'mdi mdi-sheep';
      if (s.indexOf('chicken') >= 0) return 'mdi mdi-food-drumstick';
      return 'mdi mdi-paw';
    }
  }
};
</script>
